/// <amd-module name="CodeCoverage/Timeline/Components/CodeCoverageTimelineSummary" />
import { ICodeCoverageTimelineSummaryData } from "CodeCoverage/Common/Interfaces/ICodeCoverageTimelineSummaryData";
import * as Resources from "CodeCoverage/Timeline/Resources";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import * as Utils_String from "VSS/Core/Util/String";

export interface ICodeCoverageTimelineSummaryProps extends ICodeCoverageTimelineSummaryData {}

export class CodeCoverageTimelineSummary extends VssComponent<ICodeCoverageTimelineSummaryProps, {}> {
    public render(): JSX.Element {
        const configText = this.props.buildConfiguration
            ? Utils_String.format(Resources.CodeCoverageBuildConfigurationText, this.props.buildConfiguration)
            : null;
        const platformText = this.props.buildPlatform ? Utils_String.format(Resources.CodeCoverageBuildPlatformText, this.props.buildPlatform) : null;

        /*
            Configuration: x
            Platform: y
            Configuration x | Platform: y
        */
        const buildFlavorText = (configText || "") + (configText && platformText ? " | " : "") + (platformText || "");

        return (
            <div className="codecoverage-summary-container">
                <span className="build-flavor-text">{buildFlavorText}</span>
                <div className="bar-chart-container">
                    <div className="bar-chart">
                        <div className="covered-bar" style={{ width: this.props.coveredPercentage + "%" }} />
                    </div>
                    <div className="bar-chart-subtext">
                        <span className="zero-coverage-label">{Utils_String.localeFormat("{0}%", 0)}</span>
                        <span className="full-coverage-label">{Utils_String.localeFormat("{0}%", 100)}</span>
                    </div>
                </div>
            </div>
        );
    }
}
